<template>
  <div class="box-label-border">
    <div class="header">
      <span v-text="label"></span>
    </div>
    <div class="tools" v-if="$slots['tools'] != null">
      <slot name="tools"></slot>
    </div>
    <slot></slot>
    <div class="box-overlay relative" v-if="$slots['overlay'] != null">
      <slot name="overlay"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxLabelBorder",
  props: {
    label: {
      type: String,
      default: "Label"
    }
  }
};
</script>

<style scoped>
.box-label-border:before,
.box-label-border > .header:before,
.box-label-border > .header:after {
  border-radius: 1em;
  box-sizing: border-box;
  border: 1px solid #333;
}
.box-label-border {
  position: relative;
  padding: 1em;
  margin-top: 1em;
}
.box-label-border:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top-color: transparent;
  pointer-events: none;
}
.box-label-border > .header {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  pointer-events: none;
}
.box-label-border > .header:before,
.box-label-border > .header:after {
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  height: 2em;
}
.box-label-border > .header:before {
  content: "";
  width: 2em;
  border-top-right-radius: 0;
}
.box-label-border > .header:after {
  content: "";
  flex: 1;
  border-top-left-radius: 0;
}
.box-label-border > .header > span {
  position: relative;
  top: -0.666em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.box-label-border > .tools {
  position: absolute;
  right: 0;
  top: -0.6rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: row;
  width: 100%;
  pointer-events: none;
}
.box-label-border > .tools > /deep/button:first-child {
  margin-left: auto;
}
.box-label-border > .tools > /deep/button {
  margin-left: 0.2rem;
  width: 1.2rem;
  height: 1.2rem;
  position: relative;
  pointer-events: auto;
  border-radius: 0.2rem;
}
.box-label-border > .tools > /deep/button .svg-icon {
  height: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#app.mouse .box-label-border > .tools > /deep/button:hover {
  cursor: pointer;
  background-color: var(--color-button-normal);
}
.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
